import { makeStyles } from '@mui/styles';
import TreeItem from 'apollo-react/components/TreeItem';
import TreeView from 'apollo-react/components/TreeView';
import React, { useState } from 'react';

import { useTranslation } from '../custom-hooks/useTranslation';
import { _find } from '../form-designer/utils/form-manager.utils';

const useStyles = makeStyles({
  root: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  container: {
    border: '1px solid #ccc',
    height: 'calc(100% - 25px)',
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: 'white',
  },
  right: {
    height: '100%',
    overflow: 'auto',
  },
  rightWithFooter: {
    height: 'calc(100% - 4.7rem)',
    overflow: 'auto',
  },
  footerContainer: {
    position: 'absolute',
    backgroundColor: '#8080801c',
    bottom: '0',
    left: '0',
    padding: '5px 10px',
    height: '4.7rem',
    overflow: 'auto',
    width: '100%',
  },
  footerDescription: {
    fontWeight: 'bold',
  },
});

const renderTree = ({ nodeId, label, childNodes }) => (
  <TreeItem key={nodeId} nodeId={nodeId} label={label}>
    {Array.isArray(childNodes) ? childNodes.map((node) => renderTree(node)) : null}
  </TreeItem>
);

const FormulaExpressionPicker = ({ onNodeSelect, expressionList }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const [click, setClick] = useState(0);
  const [nodeValue, setNodeValue] = useState(null);

  const handleSelect = (e, nodeIds) => {
    setClick((prev) => prev + 1);
    setNodeValue(_find(expressionList, 'nodeId', nodeIds[0]));

    setTimeout(function() {
      setClick(0);
    }, 200);

    if (click > 0) {
      handleSelectAction();
    }
  };

  const handleSelectAction = () => {
    if (nodeValue) {
      onNodeSelect((prev) => `${prev}${nodeValue.value}`);
    }
  };

  const showFormulaUsage = nodeValue && nodeValue?.usage;

  return (
    <div className={classes.root}>
      <h4>{translateString('Formula')}</h4>
      <div className={classes.container}>
        <div className={nodeValue?.usage ? classes.rightWithFooter : classes.right}>
          <TreeView
            variant="folder"
            defaultExpanded={['1']}
            defaultSelected={['1']}
            onNodeSelect={handleSelect}
            multiSelect
          >
            {expressionList.map((node) => renderTree(node))}
          </TreeView>
          {showFormulaUsage && (
            <div className={classes.footerContainer}>
              <div className={classes.footerDescription}>{nodeValue.usage}</div>
              <div>{nodeValue.description}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(FormulaExpressionPicker);
